var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivityTypeExercise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FAE7DC",
    width: 27,
    height: 27,
    rx: 10.916
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ECA073"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.799 9.92c.975-1.274 3.415-.833 4.26-.376.844.457 1.317 1.43 1.317 2.532 0 .432-.056 1.462-.523 3.292-.144.568-.31 1.122-.51 1.711-.802 2.364-1.263 2.916-2.312 3.787-1.05.87-2.635.932-4.23.941-2.078.012-2.958-.109-3.401-.408-.443-.3-.02-1.043.37-1.313.273-.187.867-.526 2.99-.685.744-.055 1.247-.408 1.794-1.202.547-.793-.455-7.365.245-8.279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.917 8.935c3.26-2.525 2.171 1.116 1.816 1.442-.355.326-1.233.393-1.458 1.241-.119.445.462.895.754 1.696.079.218.175.793-.212.865-.388.072-2.67-1.245-2.76-2.212-.055-.579.325-1.398.829-2.006a7.366 7.366 0 011.03-1.026zm9.684 4.83c.638-.411 3.446.17 4.192 1.4.746 1.231-1.64 5.025-2.355 5.973-.715.948-1.873 1.104-2.179.68-.306-.423 1.776-3.394 1.477-4.266-.299-.873-1.676-.143-2.105-.812-.366-.57.431-2.628.97-2.975zm-5.91-10.073c.834-.703 2.114-.528 2.952.505C15.48 5.229 15.869 6.64 15 7.4c-.867.759-2.291.541-3.151-.396-.86-.937-.993-2.609-.159-3.312z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTypeExercise);
export default __webpack_public_path__ + "static/media/activity-type-exercise.41fae44be5c526926698fc7414876ee0.svg";
export { ForwardRef as ReactComponent };